const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fb0005",
    d: "M 179.5,-0.5 C 230.167,-0.5 280.833,-0.5 331.5,-0.5C 336.649,1.82738 339.816,5.82738 341,11.5C 341.5,24.1623 341.667,36.8289 341.5,49.5C 284.167,49.5 226.833,49.5 169.5,49.5C 169.333,36.8289 169.5,24.1623 170,11.5C 171.184,5.82738 174.351,1.82738 179.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#fb0004",
    d: "M 76.5,77.5 C 195.834,77.3333 315.167,77.5 434.5,78C 448.333,81.1667 456.833,89.6667 460,103.5C 460.5,117.163 460.667,130.829 460.5,144.5C 323.833,144.5 187.167,144.5 50.5,144.5C 50.3334,130.829 50.5001,117.163 51,103.5C 54.3482,89.6528 62.8482,80.9861 76.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#fc0004",
    d: "M 388.5,511.5 C 299.167,511.5 209.833,511.5 120.5,511.5C 110.878,507.368 105.711,500.034 105,489.5C 97.7224,383.836 90.5558,278.17 83.5,172.5C 198.167,172.5 312.833,172.5 427.5,172.5C 419.762,279.501 411.928,386.501 404,493.5C 402.161,502.497 396.994,508.497 388.5,511.5 Z M 200.5,219.5 C 207.931,218.965 213.431,221.965 217,228.5C 217.667,298.833 217.667,369.167 217,439.5C 212.656,448.925 205.823,451.425 196.5,447C 194.083,445.337 192.25,443.171 191,440.5C 190.333,369.833 190.333,299.167 191,228.5C 193.256,224.47 196.422,221.47 200.5,219.5 Z M 303.5,219.5 C 311.415,218.873 316.915,222.206 320,229.5C 320.667,299.5 320.667,369.5 320,439.5C 314.51,449.886 306.843,451.886 297,445.5C 294.563,442.624 293.23,439.29 293,435.5C 292.333,368.167 292.333,300.833 293,233.5C 293.878,226.696 297.378,222.029 303.5,219.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/delete-item.d9a26baf8af6bd8474109229dac517af.svg";
export { ForwardRef as ReactComponent };